import serviceAxios from "@/http";
import el from "element-ui/src/locale/lang/el";

export async function getDictByType(type) {
    let dictDataStr = sessionStorage.getItem("dictData");

    let dictData;
    if (!dictDataStr){
        dictData = {};
    }else{
        dictData = JSON.parse(dictDataStr);
    }
    if(dictData[type]){
        return  dictData[type]
    }else {
        let res = await serviceAxios({
            url: '/api/system/dict/data/type/' + type,
            method: 'get'
        })
        dictData[type] = res
        sessionStorage.setItem('dictData',JSON.stringify(dictData))
        return dictData[type]
   }
}